import { AxiosResponse } from "axios";
import axios from "../../../util/payrightAxios";
import { CustomerStatementVM } from "./CustomerStatementVM";

type GenerateStatementRequest = {
  fromDate: string;
  toDate: string;
};

type GenerateStatementResult =
  | {
      success: false;
      message: string;
    }
  | {
      success: true;
      statement: CustomerStatementVM;
      message?: string;
    };

export const generateStatement = async (
  data: GenerateStatementRequest
): Promise<GenerateStatementResult> => {
  let response = await _generateStatement(data);

  // sometimes the auth token is dead but works again on a retry
  if (response.status === 401) {
    response = await _generateStatement(data);
  }

  if (response.status === 200) {
    return {
      success: true,
      statement: response.data.data,
    };
  }

  return {
    success: false,
    message: response.statusText,
  };
};

const _generateStatement = (
  data: GenerateStatementRequest
): Promise<AxiosResponse> => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const authToken = localStorage.getItem("authToken");
  const customerId = localStorage.getItem("customerId");
  const url = `${apiBaseUrl}/customer/${customerId}/statement`;

  axios.defaults.headers.common["auth-token"] = authToken;

  return axios(url, {
    method: "POST",
    data,
    validateStatus: () => true, // blocks throwing since I'm handling status codes above
  });
};
